<template>
  <v-row style="height: 100%;">
    <v-col>
      <transition name="fade-up" mode="out-in" appear>
        <router-view />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SystemAdmin',
  beforeMount() {
    const { canAccessSystemAdminSettings, userIs } = this.$store.getters;
    const userIsEmployee = userIs('employee');
    const userIsAdmin = userIs('systemAdmin');

    if (!canAccessSystemAdminSettings) {
      this.$router.push('/');
    }

    if (userIsEmployee && !userIsAdmin) {
      this.$router.push({ name: 'system-admin-partnerships' });
    }
  },
}
</script>
